// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"8b78b443","453":"56bacf93","981":"933e3b39"}[chunkId] + ".chunk.js";
};